import EventEmitter from "./EventEmitter";

export default class Resources extends EventEmitter {
  constructor (sources) {
    super();

    this.sources = sources;

    this.items = {};
    this.toLoad = this.sources.length;
    this.loaded = 0;

    this.load();
  }

  load () {
    for (const { name, path } of this.sources) {
      const image = new Image();
      image.onload = () => {
        this.sourceLoaded(name, image);
      };
      image.src = path;
    }
  }

  sourceLoaded (name, file) {
    this.items[name] = file;

    ++this.loaded;

    this.trigger("update");

    if (this.loaded === this.toLoad) this.trigger("ready");
  }
}